import { useState } from 'react';

import { DeleteOutline } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { ConfirmModal } from 'components/modal';
import { useDeleteSubgrupo } from 'pages/financeiro/dre/configuracao/hooks';
import { DreSubgrupo } from 'pages/financeiro/dre/configuracao/types';

export function DreConfigSubgruposDelete({ subgrupo }: { subgrupo: DreSubgrupo }) {
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const { handleDelete } = useDeleteSubgrupo();

    return (
        <>
            <ConfirmModal
                open={openConfirmModal}
                setOpen={setOpenConfirmModal}
                confirm={() => handleDelete(subgrupo.idDreMercadologicaGrupoExibicao)}
            />

            <IconButton sx={{ width: 30, height: 30 }} onClick={() => setOpenConfirmModal(true)}>
                <DeleteOutline />
            </IconButton>
        </>
    );
}
